module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/main-visual-a39cae8b9cd6945a267c928aa4127961.webp";